import React, {useEffect, useState} from "react";
import {Form, Input, Pagination, Select,Button} from "antd";
import TextArea from "antd/lib/input/TextArea";
import {useForm} from "antd/lib/form/Form";
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {AssignUser, CurrentLocation} from "../../store/branches/sites/stateTypes";
import {selectSitesState} from "../../store/selectors";
import {sitesAC} from "../../store/branches/sites/actionCreators";
import {CustomButton} from "../Button";
import AssignUsers from "../AssignUsers";
import InputWrap from "../InputWrap";
import {randomInteger} from "../../helpers/getRandomNumber";
import CustomConfirmationModal from "../CustomConfirmationModal";

import classes from "./EditSiteInputs.module.scss";

const {Option} = Select;

interface EditSiteProps {
    isModal?: boolean
    isDeactivateModal?: boolean
    is_suspended?: boolean
    page: number
    onRemoveSite?: () => void
    onDeactivateSite?: () => void
    onCancelDeactivateModal?: () => void
    onCancelModal?: () => void
    onChangePagination?: (page: number, pageSize: number) => void
    filterQuery: string
    setInputValue: (value: string) => void;
    handleSearch: () => void;
    handleFilterReset: () => void;
}
const {Search} = Input;
const EditSiteInputs: React.FC<EditSiteProps> = ({
                                                     onRemoveSite,
                                                     onCancelModal,
                                                     onChangePagination,
                                                     isModal,
                                                     page,
                                                     isDeactivateModal,
                                                     onDeactivateSite,
                                                     onCancelDeactivateModal,
                                                     is_suspended,
                                                     filterQuery,
                                                     setInputValue,
                                                     handleSearch,
                                                     handleFilterReset
                                                 }) => {
    const [form] = useForm();
    const dispatch = useDispatch();
    const history = useHistory();

    const [users, setUsers] = useState<AssignUser[]>([]);
    const [currentLocation, setLocation] = useState<CurrentLocation>(null);

    const {assign_users, current_location, timezones, assign_users_count} = useSelector(selectSitesState);

    const randomId = randomInteger(1, 1000);

    const onSubmit = (values: any) => {
        const data = {
            id: currentLocation?.id || randomId,
            title: values.title,
            address: values.address,
            full_name: values.full_name,
            email: values.email,
            mobile: values.mobile,
            timezone: values.timezone,
        };
        dispatch(sitesAC.updateCurrentLocation(data));
        form.resetFields();
    };

    const onCancel = () => {
        form.resetFields();
        history.push("/sites");
    };



    useEffect(() => {
        if (assign_users) {
            setUsers(assign_users);
        }
        if (current_location) {
            setLocation(current_location);
        }
        form.setFieldsValue(currentLocation);

        return () => {
            form.resetFields();
        };
    }, [form, assign_users, current_location, currentLocation, dispatch]);


    return (
        <div className={classes.wrap}>


            <Form name="edit_site_inputs"
                  form={form}
                  initialValues={{remember: true}}
                  onFinish={onSubmit}>

                <div className={classes.container}>
                    <div className={classes.groupInputs}>

                        <div className={classes.blockWrap}>
                            <InputWrap title="Title*">
                                <Form.Item name="title"
                                           initialValue={currentLocation?.title}
                                           rules={[{
                                               required: true,
                                               message: "Please input your title",
                                           }]}>
                                    <Input/>
                                </Form.Item>
                            </InputWrap>

                            <InputWrap title="Address*">
                                <Form.Item name="address"
                                           initialValue={currentLocation?.address}
                                           rules={[{
                                               required: true,
                                               message: "Please input your address",
                                           }]}>
                                    <TextArea autoSize={{minRows: 6, maxRows: 6}}/>
                                </Form.Item>
                            </InputWrap>
                        </div>

                        <div className={classes.blockWrap}>
                            <InputWrap title="Timezone*">
                                <Form.Item name="timezone"
                                           initialValue={currentLocation?.timezone}
                                           rules={[{
                                               required: true,
                                               message: "Please select your timezone!",
                                           }]}>
                                    <Select
                                        showSearch
                                        value={currentLocation?.timezone}
                                        placeholder="Search to Select"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            // @ts-ignore
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        filterSort={(optionA, optionB) =>
                                            // @ts-ignore
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                        }
                                    >
                                        {timezones?.map((item, index) => (
                                            <Option value={item} key={`${item}_time_${index}`}>{item}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </InputWrap>

                            <InputWrap title="Full name">
                                <Form.Item name="full_name" initialValue={currentLocation?.full_name}>
                                    <Input/>
                                </Form.Item>
                            </InputWrap>

                            <InputWrap title="Mobile">
                                <Form.Item name="mobile" initialValue={currentLocation?.mobile}>
                                    <Input/>
                                </Form.Item>
                            </InputWrap>

                            <InputWrap title="Email">
                                <Form.Item name="email" initialValue={currentLocation?.email}>
                                    <Input/>
                                </Form.Item>
                            </InputWrap>
                        </div>

                    </div>
                </div>
                <div className={classes.searchEmailWrap}>
                    <div className={classes.searchEmail}>
                        <div style={{display: 'flex', gap: '8px', marginBottom: '16px'}}>
                            <Search
                                placeholder="Filter by name or email"
                                onChange={(e) => setInputValue(e.target.value)}
                                onSearch={handleSearch}
                                value={filterQuery}
                                loading={false}
                                enterButton
                                size="large"
                            />
                            <CustomButton onClick={handleFilterReset} color="gray" height="40px" width="100px">
                                Reset
                            </CustomButton>
                        </div>
                  </div>
                     </div>
                        <AssignUsers users={users}/>

                        <div className={classes.paginationWrap}>
                            <Pagination current={page}
                                        pageSize={20}
                                        onChange={onChangePagination}
                                        total={assign_users_count}
                                        showSizeChanger={false}
                            />
                        </div>
                        <div className={classes.button}>
                            <Form.Item>
                                <CustomButton width="94px"
                                              height="40px"
                                              padding="2px 2px"
                                              color="gray"
                                              fontSize="13px"
                                              htmlType="button"
                                              onClick={onCancel}
                                              className="mar-right-10"
                                >
                                    <span>CANCEL</span>
                                </CustomButton>
                            </Form.Item>
                            <Form.Item>
                                <CustomButton width="123px"
                                              height="40px"
                                              padding="2px 2px"
                                              fontSize="13px"
                                              htmlType="submit"
                                >
                                    SAVE CHANGES
                                </CustomButton>
                            </Form.Item>
                        </div>
            </Form>

            <CustomConfirmationModal is_modal={isModal} onCancel={onCancelModal} onApply={onRemoveSite}
                                     message={"Please confirm you want to delete this site"}
                                     title={"Deletion"}
            />
            <CustomConfirmationModal is_modal={isDeactivateModal} onCancel={onCancelDeactivateModal}
                                     onApply={onDeactivateSite}
                                     title={is_suspended
                                         ?
                                         "Reactivation"
                                         :
                                         "Deactivation"}
                                     message={`Please confirm you want to ${is_suspended
                                         ?
                                         "reactivate"
                                         :
                                         "deactivate"} this site`}
            />
        </div>
    );
};
export default EditSiteInputs;
